module.exports = __webpack_public_path__ + "static/media/google.679ce71d.png";